import _PrivateIcon from '$lib/components/icon/_PrivateIcon.svelte';
import _PrivateImageIcon from '$lib/components/icon/_PrivateImageIcon/_PrivateImageIcon.svelte';
import { _ImageIconSources } from '$lib/components/icon/_PrivateImageIcon/source';

export const Icon = Object.assign(_PrivateIcon, {
	Image: Object.assign(_PrivateImageIcon, {
		sources: _ImageIconSources,
	}),
});
